import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Dashboard } from '../layouts/Dashboard';
import { EventCreation } from '../screens/EventCreation';
import { IssueDetails } from '../screens/IssueDetails';
import { IssueList } from '../screens/IssueList';
import { Login } from '../screens/Login';
import { NotificationCalendar } from '../screens/NotificationCalendar';
import { NotificationScheduler } from '../screens/NotificationScheduler';
import { PartnerEdit } from '../screens/PartnerEdit';
import { PartnerInviteEdit } from '../screens/PartnerInviteEdit';
import { PartnerInvites } from '../screens/PartnerInvites';
import { Partners } from '../screens/Partners';
import { Rewards } from '../screens/Rewards';
import { UbabyDetails } from '../screens/UbabyDetails';
import { UbabyList } from '../screens/UbabyList';
import { Universities } from '../screens/Universities';

function Router() {
  return (
    <Routes>
      <Route path='/login' element={<Login />} />

      <Route path='/' element={<Dashboard />}>
        <Route path='' element={<Navigate to='/partners/create' />} />
        <Route path='/partners/create' element={<Partners />} />
        <Route path='/partners/update' element={<PartnerEdit />} />

        <Route path='/partner-invites/create' element={<PartnerInvites />} />
        <Route path='/partner-invites/update' element={<PartnerInviteEdit />} />

        <Route path='/universities' element={<Universities />} />

        <Route path='/broadcast/calendar' element={<NotificationCalendar />} />
        <Route path='/broadcast/schedule' element={<NotificationScheduler />} />

        <Route path='/events/create' element={<EventCreation />} />
        <Route path='/ucoins' element={<Rewards />} />
        <Route path='/issue-list' element={<IssueList />} />
        <Route path='/issue-details/' element={<IssueDetails />} />
        <Route path='/issue-details/user/:userEmail?' element={<IssueDetails />} />
        <Route path='/issue-details/issue/:issueId?' element={<IssueDetails />} />

        <Route path='/ubaby-list' element={<UbabyList />} />
        <Route path='/ubaby-details' element={<UbabyDetails />} />
        <Route path='/ubaby-details/:phoneNumber/:month' element={<UbabyDetails />} />
      </Route>
    </Routes>
  );
}

export default Router;
